import { createContext, useContext } from 'react'

export const DashboardContext = createContext({
  selectedParameters: [],
  // Sites + active project id, shared so widgets that need project-scoped
  // data (e.g. the GPS widget on the Project Map dashboard) can read it
  // without prop-drilling through the widget registry.
  sites: [],
  projectId: null,
  dateRange: { from: '', to: '' },
  activePeriod: 'D',
  // Incremented every time Parameter Configuration (unit Convert, Sensor
  // min/max, precision, etc.) is saved — data-fetching widgets should
  // include this in their fetch effect's dependency array so a config
  // change triggers an immediate re-fetch instead of leaving the widget
  // showing a stale pre-save response.
  paramConfigVersion: 0,
  handlePeriodClick: () => {},
  setDateRange: () => {},
  isCustomizing: false,   // true when dashboard is in Customize/edit mode
  // Whether the current user may edit dashboard components (Owner/Admin only).
  // Collaborators are read-only. Defaults true so non-project contexts (and the
  // owner's own view) aren't accidentally locked; DashboardPage sets the real
  // value from the project role.
  canEdit: true,
  // Switch to the Gallery tab. Optional `albumName` deep-links to a specific
  // album sub-tab so widgets (e.g. Gallery, Project Photo) can open a
  // particular album rather than just landing on the Gallery root.
  goToGallery: (_albumName) => {},
})

export const useDashboardContext = () => useContext(DashboardContext)
